import axios from "axios";

export default axios.create({
   //baseURL: "http://localhost:4000/api/v1/auth",
   baseURL: "https://cryptoinvestos.vercel.app/api/v1/auth",
   timeout: 40000,
});
